import { html, sel, strMap } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessInboundS } from '../../../../../Inbound/S/Function/module/NessInboundS.js';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';

export const review = (reviews) => {
  return html` <div class="ness-review">
    ${NessAppPlusHomeTmplS.homeTitle({
      link: UtilS.makeApiUrl('/:lang/@/communities', { lang: T.lang }),
      title: 'Review',
      sub_title: ET('ness::home::home_05'),
      title_color: NessCoreConstantS.colors.black,
      sub_title_color: NessCoreConstantS.colors.black,
    })}
    <div class="ness-review">
      <div class="ness-review__container">
        ${strMap(
          (article) =>
            NessInboundS.nessReviewTmpl({
              article,
              store: sel('_.store', article),
            }),
          reviews,
        )}
      </div>
    </div>
  </div>`;
};
